import { almha } from './almha'
import { faculdadeInspirar } from './faculdadeInspirar'

const portfolio = [ almha, faculdadeInspirar ]

export function getCase(slug) {
    return portfolio.find(item => item.slug == slug)
}